import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export function CustomQuillEditor({
  value,
  onChange,
  modules = {},
  formats = [],
  ...props
}) {
  const defaultModules = {
    toolbar: [
      [{ font: ["sans-serif", "serif", "monospace"] }], // Agrega tus fuentes aquí
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"], // toggled buttons
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction
      [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      ["link", "image", "video"], // add's image support
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ align: [] }],
      ["clean"], // remove formatting button
    ],
    clipboard: {
      // Match visual, not semantic, which means matching the way it looks over how it might be structured semantically correctly.
      matchVisual: false,
    },
    history: {
      // Enable undo and redo buttons.
      delay: 1000,
      maxStack: 50,
      userOnly: false
    },
    ...modules,
  };

  const defaultFormats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "blockquote",
    "code-block",
    "list",
    "bullet",
    "indent",
    "direction",
    "align",
    "link",
    "image",
    "video",
    ...formats,
  ];

  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      modules={defaultModules}
      formats={defaultFormats}
      {...props}
    />
  );
}
